import { render } from "./Sekilas.vue?vue&type=template&id=b3907600"
import script from "./Sekilas.vue?vue&type=script&lang=js"
export * from "./Sekilas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__